export default __webpack_public_path__ + "static/media/ThorStarcraft2.e917f001.jpg";